import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AppRoutes } from '@rx-applications/clientsite/shared/router/data-access';
import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';

import { tap, take } from 'rxjs/operators';
import { addAbsolutePathPrefix } from '@rx-applications/shared/utils';

export const CompanyPaymentGuard: CanMatchFn = () => {
  const router = inject(Router);
  const configFacade = inject(ConfigFacade);

  return configFacade.allowCompanyPaymentPage$.pipe(
    tap((hasPermission: boolean) => {
      if (!hasPermission) {
        router.navigate([addAbsolutePathPrefix(AppRoutes.Book)]);
      }
    }),
    take(1)
  );
};